import { z } from 'zod';
/**
 * Bitemporal query parameters shared by every entity GET. Per the
 * architecture plan (.notes/architecture.next-steps.md §"API surface"):
 *
 *   at_effective  valid time   (defaults to now)
 *   at_authored   transaction time (defaults to latest)
 *   branch_id     ledger branch (defaults to org main)
 *
 * Wire format is unix epoch seconds for timestamps; branch_id is an
 * integer. All optional. The domain layer translates to its internal
 * ISO-string form for replay.
 */
export const BitemporalQuery = z.object({
    at_effective: z.coerce.number().int().nonnegative().optional(),
    at_authored: z.coerce.number().int().nonnegative().optional(),
    branch_id: z.coerce.number().int().positive().optional(),
});
/**
 * Body fields shared by every mutation: `effective_at` lets callers
 * back- or post-date a change. Defaults to now.
 */
export const EffectiveAtBody = z.object({
    effective_at: z.number().int().nonnegative().optional(),
});
//# sourceMappingURL=bitemporal.js.map